import { useState } from "react";
import { PRINTERS } from "../config/printers";

/**
 * Modal for selecting a printer when starting a PRINT-MACH job
 */
export default function PrinterSelectModal({ job, onSelect, onCancel }) {
  const [selectedPrinter, setSelectedPrinter] = useState(null);

  const handleSubmit = () => {
    if (!selectedPrinter) {
      return;
    }
    onSelect(selectedPrinter);
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/70"
        onClick={onCancel}
      />

      {/* Modal */}
      <div className="relative bg-white border border-gray-200 rounded-xl shadow-2xl w-full max-w-md mx-4 overflow-hidden">
        {/* Header */}
        <div className="px-6 py-4 border-b border-gray-200 bg-slate-100">
          <h2 className="text-lg font-semibold text-gray-900">Select Printer</h2>
          <p className="text-sm text-gray-500 mt-1">
            Choose which printer will be used for this job
          </p>
        </div>

        {/* Job Info */}
        <div className="px-6 py-3 border-b border-gray-200 bg-slate-200">
          <p className="text-sm text-gray-700">
            <span className="text-gray-500">Job:</span>{" "}
            <span className="font-medium">{job?.jobNumber || job?.name || "Unknown"}</span>
          </p>
        </div>

        {/* Printer Grid */}
        <div className="px-6 py-4 max-h-[50vh] overflow-y-auto">
          <div className="grid grid-cols-2 gap-3">
            {PRINTERS.map((printer) => (
              <button
                key={printer.id}
                onClick={() => setSelectedPrinter(printer)}
                className={`
                  p-3 rounded-lg border text-left transition-all flex items-center gap-3
                  ${
                    selectedPrinter?.id === printer.id
                      ? "bg-blue-600 border-blue-500 text-gray-900"
                      : "bg-slate-100 border-gray-300 text-gray-800 hover:bg-slate-100 hover:border-gray-500"
                  }
                `}
              >
                {printer.icon && (
                  <img
                    src={`${import.meta.env.BASE_URL}printers/${printer.icon}.png`}
                    alt={printer.name}
                    className="w-10 h-10 rounded-full object-cover border-2 border-gray-300 flex-shrink-0"
                    onError={(e) => { e.target.style.display = 'none'; }}
                  />
                )}
                <div className="min-w-0">
                  <span className="text-sm font-medium block truncate">{printer.name}</span>
                  {printer.model && (
                    <span className={`text-xs ${selectedPrinter?.id === printer.id ? 'text-blue-200' : 'text-gray-500'}`}>
                      {printer.model}
                    </span>
                  )}
                </div>
              </button>
            ))}
          </div>
        </div>

        {/* Actions */}
        <div className="px-6 py-4 border-t border-gray-200 bg-slate-100 flex justify-end gap-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 rounded-lg bg-gray-700 hover:bg-gray-600 text-gray-800 text-sm font-medium transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={!selectedPrinter}
            className={`
              px-4 py-2 rounded-lg text-sm font-medium transition-colors
              ${
                selectedPrinter
                  ? "bg-blue-600 hover:bg-blue-700 text-gray-900"
                  : "bg-gray-600 text-gray-500 cursor-not-allowed"
              }
            `}
          >
            Start Job
          </button>
        </div>
      </div>
    </div>
  );
}
